import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import bg2 from 'assets/img/generic/bg-3.jpg';
import Section from 'components/common/Section';
import { Link } from 'react-router-dom';

const Cta = () => (
 <Section overlay image={bg2} position="center top" className="light bg-dark">
  <Row className="justify-content-center text-center">
   <Col lg={8}>
    <p className="fs-3 fs-sm-4 text-white">
     ¿Estás buscando una solución innovadora y completa para el cuidado de la salud de tu mascota? ¡Fortis Control es tu
     solución!.
    </p>
    <Button
     as={Link}
     variant="outline-light"
     size="lg"
     className="border-2 rounded-pill mt-4 fs-0 py-2"
     to="/authentication/card/register"
    >
     Regístrate Gratis (o Contáctanos para más información)
    </Button>
   </Col>
  </Row>
 </Section>
);

export default Cta;
